import React, { useContext, useEffect, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import { AuthContext } from "../../routes/AuthContext";
import Logo from "../../assets/img/deligate(1).png"; // ✅ Replace your old deligate.png with the new cropped one
import "./Header.css";

const BASE_URL = process.env.REACT_APP_API_BASE_URL;

const Header = () => {
  const navigate = useNavigate();
  const { isLoggedIn, isAuthenticated, cartCount } = useContext(AuthContext);
  const loggedIn = isLoggedIn || isAuthenticated;
  const [searchText, setSearchText] = useState("");
  const [results, setResults] = useState([]);
  const [showDropdown, setShowDropdown] = useState(false);
  const searchRef = useRef(null);

  useEffect(() => {
    if (searchText.trim().length < 2) {
      setResults([]);
      return;
    }
    const fetchSearch = async () => {
      try {
        const formData = new FormData();
        formData.append("search_key", searchText);
        const res = await axios.post(`${BASE_URL}product_search`, formData);
        setResults(res.data.products || []);
        setShowDropdown(true);
      } catch (err) {
        console.error("Search error", err);
      }
    };
    const delay = setTimeout(fetchSearch, 400);
    return () => clearTimeout(delay);
  }, [searchText]);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (searchRef.current && !searchRef.current.contains(e.target)) {
        setShowDropdown(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <header className="app-header">

      {/* LEFT */}
      <div className="dg-header-left">
        <Link to="/" className="dg-brand-logo">
          <img src={Logo} alt="Deligate" className="dg-brand-logo-img" />
        </Link>
        <div className="dg-location-selector">
          Select Location <i className="bi bi-chevron-down"></i>
        </div>
      </div>

      {/* SEARCH */}
      <div className="dg-header-search" ref={searchRef}>
        <i className="bi bi-search"></i>
        <input
          type="text"
          placeholder='Search for "Vegetables"'
          value={searchText}
          onChange={(e) => setSearchText(e.target.value)}
          onFocus={() => searchText && setShowDropdown(true)}
        />
        {showDropdown && results.length > 0 && (
          <div className="dg-search-dropdown">
            {results.map((item) => (
              <div
                key={item.product_id}
                className="dg-search-item"
                onClick={() => {
                  navigate(`/product-details/${item.product_id}`);
                  setShowDropdown(false);
                  setSearchText("");
                }}
              >
                <img src={item.product_image} alt={item.product_name} />
                <div>
                  <p className="dg-item-name">{item.product_name}</p>
                  <span className="dg-item-price">₹{item.price}</span>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>

      {/* RIGHT */}
      <div className="dg-header-right">
        <div
          className="dg-header-action"
          onClick={() => navigate(loggedIn ? "/account" : "/login")}
        >
          <i className="bi bi-person"></i>
          <span>{loggedIn ? "Profile" : "Login"}</span>
        </div>
        <Link to="/cart" className="dg-header-action dg-cart-wrapper">
          <i className="bi bi-cart"></i>
          {cartCount > 0 && <span className="dg-cart-badge">{cartCount}</span>}
          <span>Cart</span>
        </Link>
      </div>

    </header>
  );
};

export default Header;